export class HeaderController {
    constructor($log, $state, AppConfig, UserSessionService) {
        'ngInject';

        this.$log = $log;
        this.$state = $state;
        this.appConfig = AppConfig;
        this.userSessionService = UserSessionService;

    }
    showDrawView() {
        this.$state.go('draw');
    }

    showDesignView() {
        this.$state.go('design', {blah: true});
    }

    showSummaryView() {
        this.$state.go('summary');
    }

    isDesignVisible() {
        return this.$state.current.name === 'draw' && this.userSessionService.getDoors().length;
    }

    isSummaryVisible() {

        //this.$log.debug('doors configured', this.userSessionService.allDoorsConfigured());

        return this.$state.current.name === 'design' && this.userSessionService.allDoorsConfigured();
    }
}



// WEBPACK FOOTER //
// ./src/js/components/header/header.controller.js